import { TPromoSearchTypes } from '../../types/promoSearchTypes';

export function getValueToTagLabelMap(newbuildingPromoSearchTypes: NonNullable<TPromoSearchTypes>) {
  const valueToTagLabelMap = new Map<string, string>();

  const allPromoSearchTypes = newbuildingPromoSearchTypes.mortgage.concat(newbuildingPromoSearchTypes.discount);

  allPromoSearchTypes.forEach(item => {
    valueToTagLabelMap.set(item.value, item.fullName);
  });

  return valueToTagLabelMap;
}
